import React from 'react';
import { Button, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';

/**
 * One Export button that opens the same format menu as Users / Itineraries
 * (CP-8289). A single action renders as a plain button. `hideLabel` is the
 * phone header: icon only, no menu arrow, label in a tooltip (CP-8292).
 *
 * `actions` entries may be false (a permission check that failed); those
 * are dropped.
 */
const ExportMenuButton = ({ actions, size = 'small', hideLabel = false, disabled = false, sx }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const items = (actions || []).filter(Boolean);
    if (!items.length) return null;

    const close = () => setAnchorEl(null);
    const label = 'Export';

    if (items.length === 1) {
        const only = items[0];
        const button = (
            <Button
                onClick={only.onClick}
                variant="outlined"
                color="primary"
                size={size}
                disabled={disabled}
                aria-label={label}
                sx={{ whiteSpace: 'nowrap', ...(hideLabel ? { minWidth: 0 } : null), ...sx }}
                startIcon={hideLabel ? undefined : <FileUploadOutlinedIcon />}
            >
                {hideLabel ? <FileUploadOutlinedIcon /> : label}
            </Button>
        );
        return hideLabel ? <Tooltip title={label}><span>{button}</span></Tooltip> : button;
    }

    const openMenu = (ev) => setAnchorEl(ev.currentTarget);
    const button = hideLabel ? (
        <Tooltip title={label}>
            <span>
                <Button
                    onClick={openMenu}
                    variant="outlined"
                    color="primary"
                    size={size}
                    disabled={disabled}
                    aria-label={label}
                    sx={{ minWidth: 0, ...sx }}
                >
                    <FileUploadOutlinedIcon />
                </Button>
            </span>
        </Tooltip>
    ) : (
        <Button
            onClick={openMenu}
            variant="outlined"
            color="primary"
            size={size}
            disabled={disabled}
            aria-label={label}
            sx={{ whiteSpace: 'nowrap', ...sx }}
            startIcon={<FileUploadOutlinedIcon />}
            endIcon={<ArrowDropDownIcon />}
        >
            {label}
        </Button>
    );

    return (
        <>
            {button}
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={close}>
                {items.map((item) => (
                    <MenuItem
                        key={item.key}
                        onClick={() => {
                            close();
                            item.onClick();
                        }}
                    >
                        {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
                        <ListItemText>{item.label}</ListItemText>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default ExportMenuButton;
